import React, { memo } from "react";
import { useTranslation } from "react-i18next";

interface ReportsEmptyStateProps {
  hasSearchTerm: boolean;
}

const ReportsEmptyState: React.FC<ReportsEmptyStateProps> = memo(({ hasSearchTerm }) => {
  const { t } = useTranslation();
  return (
    <div className="no-reports">
      {hasSearchTerm
        ? t("report.noReportsSearch")
        : t("report.noReports")}
    </div>
  );
});

ReportsEmptyState.displayName = "ReportsEmptyState";

export default ReportsEmptyState;
